import { useEffect } from 'react';
import useClearAll from '@components/MainStage/hooks/useClearAll';
import { isEditableTextTarget } from '@utils/isEditableTextTarget';

/**
 * Esc clears the whole canvas state in a single press — multi-selection, Focus
 * On, list search, and all filters (AC9). Registered globally while the model
 * canvas is mounted (model tab, including what-if scenarios).
 *
 * Esc while typing in an editable field (list search, filter inputs, drawer
 * inputs) is left to that field; the list search field triggers the same
 * clear-all from its own handler (see ListMenuHeader).
 */
const useClearAllShortcut = () => {
  const clearAll = useClearAll();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;

      if (isEditableTextTarget(document.activeElement)) return;

      clearAll();
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [clearAll]);
};

export default useClearAllShortcut;
